import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../environments/environment.prod";
import { Router } from '@angular/router';
import { Plugins } from '@capacitor/core';
import { LoadingController, ToastController, MenuController, AlertController, Platform, PopoverController, ModalController} from '@ionic/angular';
import { ImageCompressorService, CompressorConfig } from 'ngx-image-compressor';
import { NewmasivadownloadPage } from "./components/newmasivadownload/newmasivadownload.page";
import { DatePipe, CurrencyPipe } from "@angular/common";
import * as XLSX from 'xlsx';

import { DomSanitizer } from '@angular/platform-browser';


const { Storage } = Plugins;

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  HTTPoptions = { headers: new HttpHeaders({ 
    'Content-Type': 'application/json', 
    'Authorization':environment.Authorization
  }) };

  loading;
  temporizador;
  apiOnReq;

  login=false;
  user;
  dashboarUser;

  clave;
  usuario;
  correo;

  title;
  show;
  showTitle;
  timeShowTitle = 50;

  desShowOp;
  facShowOp;

  publicaciones = [];
  publicacionesPre;
  publicacionesFilt=[];
  estados = [
    {value:"0",nombre:"Inactivo"},
    {value:"1",nombre:"Activo"},
    {value:"2",nombre:"Pendiente revisión"},
    {value:"3",nombre:"Pendiente cambios"}
  ]
  estadosSelectValue = ["0","1","2","3"];
  totPubActivas=0;
  totPubPendRev=0;
  totPubInactivas=0;
  totPubPendChan=0

  busqueda1="";
  busqueda2="";
  busqueda3="";
  busqueda4="";

  producto;
  productoPre;
  productoNew = {
    Cantidad:1,
    Categoria:null,
    Categorias:null,
    CodUniversal:null,
    Condicion:"Nuevo",
    Estado:2,
    EstadoN:null,
    Id:null,
    IdCategoria:null,
    IdColor:null,
    IdCondicion:1,
    Marca:null,
    Modelo:null,
    Preguntas:[],
    Regdate:null,
    Stock:10,
    TipoPub:null,
    Titulo:null,
    UrlFotos:[],
    Usr:null,
    ValorUnt:null,
    categoria: null
    ,StockPRH:50
    ,StockAlert:20
    ,StockCong:10
    ,IVA:19
    ,Comision:10
    ,DescPromo:0
    ,FechaIniPromo:'2000-12-31'
    ,FechaFinPromo:'2000-12-31'
    ,DescDenario:0
    ,FechaIniDenario:'2000-12-31'
    ,FechaFinDenario:'2000-12-31'
    ,DescOtros:0
    ,FechaIniOtros:'2000-12-31'
    ,FechaFinOtros:'2000-12-31'
    ,Peso:10
    ,Dimension:{
      Ancho:10,
      Alto:10,
      Largo:10
    }
  }
  isProductNew = false;
  isProductCreated = false;

  productoMasivo = {
     CodUniversal:null
    ,Titulo:null
    ,Marca:null
    ,Modelo:null
    ,Condicion:"Nuevo"
    ,ValorUnt:null
    ,IVA:19
    ,Comision:10
    ,DescPromo:0
    ,FechaIniPromo:'2000-12-31'
    ,FechaFinPromo:'2000-12-31'
    ,Stock:10
    ,StockPRH:50
    ,Peso:10
    ,Ancho:10
    ,Alto:10
    ,Largo:10
    ,Descripcion:null
    ,UrlFotos:null
    ,IdCategoria:null
    ,Cat1:null
    ,Cat2:null
    ,Cat3:null
  }

  filePublicMas;

  productosToUpMas = [];

  estadosProd=[
    {value:1,nombre:'Nuevo'},
    {value:2,nombre:'Usado'}
  ]

  cat=[];
  cat1=[];
  cat2=[];
  cat3=[];
  cat1Select=[];
  cat2Select=[];
  cat3Select = [];

  IdCat;
  IdCat1;
  IdCat2;
  IdCat3;
  IdCatObj;
  IdCat1Obj;
  IdCat2Obj;
  IdCat3Obj;
  
  
  foto = {
    index: null,
    url: null,
    ancho: null,
    alto: null,
    tipo: null 
  };

  files = [];
  filesUpCount = 0;
  filesUpCountPor = 0;
  cargarFilesEn = true;

  filesDes = [];

  anchoP;
  maxSize = 150000;

  ppr=0;
  ppc = 0;
  dp = 0;
  
  Despachos = [];
  DespachosFilt = [];

  fechaHoy = new Date(Date.now());
  fechaHoyF;

  estadosDesp = [
    {
      id: 0,
      name: "Pendiente desembolso",
      descripcion: "La solicitud esta pendiente de desembolso y pendiente de aprobación de la administración de market"
    },
    {
      id: 1,
      name: "Solicitado",
      descripcion: "Se ha solicitado el producto al vendedor"
    },
    {
      id: 2,
      name: "Aceptado",
      descripcion: "El vendedor está alistando el pedido"
    },
    {
      id: 3,
      name: "Enviado",
      descripcion: "El pedido va en camino"
    },
    {
      id: 4,
      name: "Entregado",
      descripcion: "Pedido entregado, pendiente de verificación por parte de administración market Denario"
    },
    {
      id: 5,
      name: "Terminado",
      descripcion: "Administración market Denario ha verificado la entrega del pedido"
    },
    {
      id: 6,
      name: "Percance",
      descripcion: "Problema al alistar o durante el transito del pedido antes de la entrega"
    },
    {
      id: 7,
      name: "Cancelado",
      descripcion: "Pedido cancelado. Por el vendedor cuando esté en estado de solicitado o por administración market Denario en cualquier momento"
    },
  ];

  estadosDespSelectValue = ["0","1","2","3","4","5","6","7"];

  estadosProveedor = [
    {
      id: 1,
      name: "Activo"
    },
    {
      id: 0,
      name: "Inactivo"
    }
  ]

  estadosProveedorSelectValue = ["0", "1"];

  metodosPago = [
    {
      id: 1,
      name: "Den"
    },
    {
      id: 2,
      name: "PSE"
    },
    {
      id: 3,
      name: "TpagaBtn"
    },
    {
      id: 4,
      name: "TpagaMini"
    },
    {
      id: 5,
      name: "Denarios"
    },
    {
      id: 10,
      name: "Gmovil"
    }
  ];

  totPendDes={
    tot:0,
    descripcion:this.estadosDesp[0].descripcion
  };
  totSolicitados={
    tot:0,
    descripcion:this.estadosDesp[1].descripcion
  };
  totAceptados={
    tot:0,
    descripcion:this.estadosDesp[2].descripcion
  };
  totPercances={
    tot:0,
    descripcion:this.estadosDesp[6].descripcion
  };
  totCancelados={
    tot:0,
    descripcion:this.estadosDesp[7].descripcion
  };

  despacho;
  publicUpN=0;
  publicUpP=0;

  productoDesp;

  estDesp;
  obsDesp = "";
  imgDesp = "";

  imgVisor;

  clipBoard = "";

  countUP_1 = 0;
  plantillaLength = 0;
  showLoad = false;

  proveedor;
  isNewProv = false;

  encCobros = [];
  encCobrosFilt = [];
  cobro:any = {};

  constructor(
    public http: HttpClient,
    public router: Router,
    public loadingController: LoadingController,
    public toastController: ToastController,
    public menu: MenuController,
    public alertController: AlertController,
    public plt: Platform,
    public imageCompressor: ImageCompressorService,
    public popoverController: PopoverController,
    public datePipe: DatePipe,
    public modalController: ModalController,
    public currencyPipe:CurrencyPipe,
    public dom:DomSanitizer
  ) {
    console.log('hola desde api service!');
    /* this.router.navigate(['/pageprev']); */
    this.anchoP = plt.width();
    console.log('platform: ', this.anchoP);
    this.fechaHoyF = this.fechaHoy.getFullYear()+"-"+("0" + (this.fechaHoy.getMonth() + 1)).slice(-2)+"-"+("0" + this.fechaHoy.getDate()).slice(-2);
    console.log('fechaHoyF: ',this.fechaHoyF);

    /* this.init(); */
    /* if (!this.login) { this.router.navigate(['/login']); } */
  }

  async init(){
    await Storage.get({ key: 'loginMarketDen' })
      .then( async (res) => {
        console.log('Storageget: ',res);
        let resJSON = JSON.parse(res.value);
        console.log('resJSON: ', resJSON);
        if (resJSON) {
          /* this.user = resJSON.user; */
          this.user = await this.getUser(resJSON.user.Usuario);
          if(this.user.LinkDashboard != null){ this.dashboarUser = this.transformUrl(this.user.LinkDashboard) }
          console.log('ssssssssss ', this.user);
          this.getSesion();
        }else{
          this.router.navigate(['login']);
        }
      })
      .catch((err) => {
        console.log('error Storageget: ', err);
        this.router.navigate(['/login']);
      });
  }

  async getUser(usr){
    let usuario;
    const body={usr:usr}
    await this.req('post','market/getUser',body,'Obteniendo usuario...')
      .then((res)=>{
        usuario = res;
      })
      .catch((err) => {
        this.presentAlert('Error','Al obtener usuario',JSON.stringify(err));
      });
    return usuario;
  }

  exportAsExcelFile(json: any[],nombre: string) {
    let fecha = new Date();
    let fechaForm = fecha.getFullYear()+'-'+(fecha.getMonth()+1)+'-'+fecha.getDate()+'_'+fecha.getHours()+'-'+fecha.getMinutes();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, nombre);
    XLSX.writeFile(wb, nombre+'_'+fechaForm+'.xlsx');
  }

  async presentAlert(titulo,subtitulo,mensaje) {
    const alert = await this.alertController.create({
      mode:'ios',
      header: titulo,
      subHeader: subtitulo,
      message: mensaje,
      buttons: ['OK']
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
    console.log('onDidDismiss resolved with role', role);
  }

  async getSesion(){
    console.log('Obteniendo permisos...');
    /* await this.presentLoading('Obteniendo permisos...');
    this.apiOnReq = true; */
    let body = {
      usr:this.user.Usuario
    };
    this.http.post(environment.urlApi + 'seseionnewmarket',body,this.HTTPoptions).subscribe((res:any)=>{
      console.log('getSesion',res);
      if(res.Act && !res.ForeceLog){
        this.login = true;
        /* this.router.navigate(['/dashboard']); */
        this.getDataDashMk();
      }else{
        this.router.navigate(['/login']);
        this.logOut();
      }
      /* this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador); */
    },
    (err) => {
      console.log('Error http: ', err);
      /* this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador); */
      alert('Error: '+err.error.originalError.info.message);
    })
  }



  async presentLoading(mensaje) {
    this.loading = await this.loadingController.create({
      mode:'ios',
      message: mensaje
    });
    await this.loading.present();
    this.temporizador = setTimeout(() => {
      if(this.apiOnReq){
        this.loading.dismiss();
        this.apiOnReq = false;
        console.log('Mucho tiempo esperando respuesta del api');
      }
    }, 30000);
  }

  async presentToast(mensaje,color='primary') {
    const toast = await this.toastController.create({
      message: mensaje,
      position:'bottom',
      duration: 3000,
      color: color,
      mode:'ios'
    });
    toast.present();
  }


  openLoginMenu() {
    this.menu.enable(true, 'end');
    this.menu.open('end');
  }

  openCustom() {
    this.menu.enable(true, 'custom');
    this.menu.open('custom');
  }

  desShow() {
    if (this.desShowOp) { this.desShowOp = false; } else { this.desShowOp = true;}
  }

  facShow() {
    if (this.facShowOp) { this.facShowOp = false; } else { this.facShowOp = true;}
  }


  irDashboard(){
    this.menu.close('custom')
    this.router.navigate(['/dashboard']);
  }

  irDesPendientes(){
    this.menu.close('custom')
    this.router.navigate(['/despachospendientes']);
  }

  irDesRealizados(){
    this.menu.close('custom')
    this.router.navigate(['/despachosrealizados']);
  }

  irPublicaciones(){
    this.menu.close('custom')
    this.router.navigate(['/publicaciones']);
  }

  irFacPendientes(){
    this.menu.close('custom')
    this.router.navigate(['/facturaspendientes']);
  }

  irFacRealizados(){
    this.menu.close('custom')
    this.router.navigate(['/facturasrealizadas']);
  }

  irProveedores(){
    this.menu.close('custom')
    this.router.navigate(['/proveedores']);
  }

  irUsuarios(){
    this.menu.close('custom')
    this.router.navigate(['/usuarios']);
  }

  irUploadImages() {
    this.router.navigate(['/uploadimages']);
  }

  irPublicNew() {
    this.producto = this.productoNew;
    this.isProductNew = true;
    this.isProductCreated = false;
    this.router.navigate(['/publicdetalle']);
  }

  showPublicDetail(producto){
    this.producto = producto;
    let catSplit = this.producto.Categorias.split(",");
    this.producto.IdCategoria = this.producto.IdCategoria.toString();
    console.log('catSplit: ',catSplit);
    if(catSplit[0]){this.producto.Cat1 = catSplit[0];}
    if(catSplit[1]){this.producto.Cat2 = catSplit[1];}
    if(catSplit[2]){this.producto.Cat3 = catSplit[2];}
    this.producto.categoria = this.cat.filter(c => c.IdCategoria == this.producto.IdCategoria)[0];
    this.cat1Select = this.cat1.filter(c => c.IdBoton == this.producto.IdCategoria);
    this.cat2Select = this.cat2.filter(c => c.IdCat1 == this.producto.Cat1);
    this.cat3Select = this.cat3.filter(c => c.IdCat2 == this.producto.Cat2);
    this.producto.DescPromoVal = (this.producto.ValorUnt * (100 - this.producto.DescPromo) / 100);
    this.producto.PreguntasLength = 0;
    if (this.producto.Preguntas.length > 0) {
      this.producto.PreguntasLength = JSON.stringify(this.producto.Preguntas).length;
    }

    const dimensionArray = this.producto.DimensionStr.split(',');
    this.producto.Dimension = {
      Ancho: dimensionArray[0],
      Alto: dimensionArray[1],
      Largo: dimensionArray[2]
    }
    
    console.log('Producto: ',this.producto);
    this.productoPre = JSON.stringify(this.producto);
    this.publicacionesPre = JSON.stringify(this.publicaciones);
    /* console.log('productoPre: ', this.productoPre); */
    if (this.producto.Estado == 2 || this.producto.Estado == 3) { this.isProductNew = true; this.isProductCreated = true;}
    else { this.isProductNew = false; }
    this.router.navigate(['/publicdetalle']);
  }

  irVisor(img){
    this.imgVisor=img
    this.router.navigate(['/visor-img']);
  }

  irNewCategoria(){
    this.cat1Select=[];this.IdCat1=null;
    this.cat2Select=[];this.IdCat2=null;
    this.cat3Select=[];this.IdCat3=null;
    this.router.navigate(['/newcategoria']);
  }

  async getDetDespacho(id){
    console.log('Obteniendo DetDespacho...');
    await this.presentLoading('Obteniendo detalles de despacho...');
    this.apiOnReq = true;
    let body = {
      id:id
    };
    this.http.post(environment.urlApi + 'getdetdespacho', body).subscribe((res: any) => {
      console.log('getDetDespacho: ', res.body);
      if (res.body) {
        Object.assign(this.despacho, res.body);
        if(res.body.ImgAcept){this.despacho.ImgAceptArray = res.body.ImgAcept.split(",,");}
        if(res.body.ImgEnt){this.despacho.ImgEntArray = res.body.ImgEnt.split(",,");}
        if(res.body.ImgEnv){this.despacho.ImgEnvArray = res.body.ImgEnv.split(",,");}
        if(res.body.ImgPerc){this.despacho.ImgPercArray = res.body.ImgPerc.split(",,");}
        if(res.body.ImgSol){this.despacho.ImgSolArray = res.body.ImgSol.split(",,");}
        if(res.body.ImgSolRech){this.despacho.ImgSolRechArray = res.body.ImgSolRech.split(",,");}
        if(res.body.ImgTerm){this.despacho.ImgTermArray = res.body.ImgTerm.split(",,");}
      }
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
    },
    (err) => {
      console.log('Error http: ', err);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      alert('Error: '+err.body.error.originalError.info.message);
    })
  }

  showDespachoDetail(desp) {
    this.despacho = desp;
    this.getDetDespacho(desp.Id);
    console.log("despacho: ", this.despacho);
    this.router.navigate(['/despachodetalle']);
  }

  async irFoto(foto: string) {
    this.foto.index = this.producto.UrlFotos.indexOf(foto);
    this.foto.url = foto;
    let fotoObj = new Image();
    fotoObj.src = foto;
    fotoObj.onload = () => {
      this.foto.ancho = fotoObj.width;
      this.foto.alto = fotoObj.height;
      let type = fotoObj.src.split(".");
      this.foto.tipo = type[type.length - 1]
      console.log('foto: ', this.foto);
    }
    this.router.navigate(['/foto']);
  }


  async borrarFotoAlertConfirm() {
    const alert = await this.alertController.create({
      cssClass: 'alertClass',
      header: 'Confirma!',
      message: '¿Estás seguro de eliminar ésta imágen?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Eliminar',
          handler: () => {
            this.borrarFoto();
          }
        }
      ]
    });
    await alert.present();
  }

  borrarFoto() {
    let index = this.producto.UrlFotos.indexOf(this.foto.url)
    this.producto.UrlFotos.splice(index, 1);
    this.router.navigate(['/publicdetalle']);
  }

  arrayFotosMove(old_index,new_index){
    if (new_index >= this.producto.UrlFotos.length) {
      var k = new_index - this.producto.UrlFotos.length + 1;
      while (k--) {
        this.producto.UrlFotos.push(undefined);
      }
    }
    this.producto.UrlFotos.splice(new_index, 0, this.producto.UrlFotos.splice(old_index, 1)[0]);
  }

  arrayPreguntasMove(old_index,new_index){
    if (new_index >= this.producto.Preguntas.length) {
      var k = new_index - this.producto.Preguntas.length + 1;
      while (k--) {
        this.producto.Preguntas.push(undefined);
      }
    }
    this.producto.Preguntas.splice(new_index, 0, this.producto.Preguntas.splice(old_index, 1)[0]);
  }

  addFoto() {
    
  }

  async filesChan(event){
    await this.presentLoading('Adaptando archivos, por favor espera...');
    let filesArr = event.target.files
    console.log('filesChan: ',filesArr);
    this.files = [];
    for(let f of filesArr){

      if(f.size>this.maxSize){
        let q = 50;
        let sizeAnt = 0;
        let qmax = 100;
        let qmin = 0;
        let newF = f;
        let countN = 0;
        let maxSizeAnt = this.maxSize;
        while ((newF.size > this.maxSize + 10000 || newF.size < this.maxSize - 10000) && countN<20) {
          console.log('calidad: ',q);
          const config: CompressorConfig = { orientation: 1, ratio: 50, quality: q };
          const compressedFile: File = await this.imageCompressor.compressFile(f, config);
          newF = compressedFile;
          console.log('newSize: ',newF.size);
          if (newF.size > this.maxSize) {
            qmax = q;
            q = (q + qmin) / 2;
            q = Math.round(q * 1000) / 1000;
            if (sizeAnt == newF.size) { f = newF; q=100; this.maxSize=400000;}
            sizeAnt = newF.size;
          }
          else {
            qmin = q;
            q = (q + qmax) / 2;
            q = Math.round(q * 1000) / 1000;
            if (sizeAnt == newF.size) { countN = 100; }
            sizeAnt = newF.size;
          }
          console.log('countN: ', countN);
          countN = countN+1
        }
        this.maxSize=maxSizeAnt;
        f=newF;
        console.log("compressedFile: ",f);
      }

      let reader = new FileReader();
      reader.onload = (e) => {
        let img = new Image;
        img.src = reader.result.toString();
        img.onload = () => {
          this.files.push({
            name:f.name,
            type:f.type,
            size: f.size,
            width: img.width,
            height: img.height,
            base: reader.result
          })
        }
      };
      reader.readAsDataURL(f);
    }
    console.log('files: ', this.files);
    this.loading.dismiss();
    clearTimeout(this.temporizador);
  }



  async filesChanPdes(event){
    await this.presentLoading('Adaptando archivos, por favor espera...');
    let filesArr = event.target.files
    console.log('filesChan: ',filesArr);
    this.filesDes = [];
    for(let f of filesArr){

      if(f.size>this.maxSize){
        let q = 50;
        let sizeAnt = 0;
        let qmax = 100;
        let qmin = 0;
        let newF = f;
        let countN = 0;
        let maxSizeAnt = this.maxSize;
        while ((newF.size > this.maxSize + 10000 || newF.size < this.maxSize - 10000) && countN<20) {
          console.log('calidad: ',q);
          const config: CompressorConfig = { orientation: 1, ratio: 50, quality: q };
          const compressedFile: File = await this.imageCompressor.compressFile(f, config);
          newF = compressedFile;
          console.log('newSize: ',newF.size);
          if (newF.size > this.maxSize) {
            qmax = q;
            q = (q + qmin) / 2;
            q = Math.round(q * 1000) / 1000;
            if (sizeAnt == newF.size) { f = newF; q=100; this.maxSize=400000;}
            sizeAnt = newF.size;
          }
          else {
            qmin = q;
            q = (q + qmax) / 2;
            q = Math.round(q * 1000) / 1000;
            if (sizeAnt == newF.size) { countN = 100; }
            sizeAnt = newF.size;
          }
          console.log('countN: ', countN);
          countN = countN+1
        }
        this.maxSize=maxSizeAnt;
        f=newF;
        console.log("compressedFile: ",f);
      }

      let reader = new FileReader();
      reader.onload = (e) => {
        let img = new Image;
        img.src = reader.result.toString();
        img.onload = () => {
          this.filesDes.push({
            name:f.name,
            type:f.type,
            size: f.size,
            width: img.width,
            height: img.height,
            base: reader.result
          })
        }
      };
      reader.readAsDataURL(f);
    }
    console.log('files: ', this.filesDes);
    this.loading.dismiss();
    clearTimeout(this.temporizador);
  }

  

  async cargarToAWS(){
    this.filesUpCount = 0;
    this.cargarFilesEn = false;
    for(let file of this.files){
      console.log('file: ',file.name);
      let body = {
        name: file.name,
        type: file.type,
        file: file.base
      };
      let promesa = new Promise((resolve,reject)=>{
        this.http.post(environment.urlApi + 'putimgs3',body).subscribe((res:any)=>{
          console.log('putimgs3: ',res);
          resolve(res.url);
        },
        (err)=>{
          console.log('error al cargar imagen: ',err);
          reject(0);
        });
      })
      let urladd = await promesa;
      if(urladd){
        this.producto.UrlFotos.push(urladd);
        this.filesUpCount = this.filesUpCount + 1;
        this.filesUpCountPor = this.filesUpCount/this.files.length;
      }
    } 
    console.log('producto: ', this.producto);
    this.files = [];
    this.filesUpCount = 0;
    this.cargarFilesEn = true;
    this.filesUpCountPor = 0;
    this.router.navigate(['/publicdetalle']);
  }
 
  async cargarToAWSDes(){
    this.filesUpCount = 0;
    this.cargarFilesEn = false;
    this.imgDesp = "";
    for(let file of this.filesDes){
      console.log('file: ',file.name);
      let body = {
        name: file.name,
        type: file.type,
        file: file.base
      };
      let promesa = new Promise((resolve,reject)=>{
        this.http.post(environment.urlApi + 'putimgs3',body).subscribe((res:any)=>{
          console.log('putimgs3: ',res);
          resolve(res.url);
        },
        (err)=>{
          console.log('error al cargar imagen: ',err);
          reject(0);
        });
      })
      let urladd = await promesa;
      if(urladd){
        if(this.imgDesp == ""){this.imgDesp = urladd.toString();} else { this.imgDesp = this.imgDesp + ",," + urladd }
        this.filesUpCount = this.filesUpCount + 1;
        this.filesUpCountPor = this.filesUpCount/this.filesDes.length;
      }
    } 

    this.putDetDespacho()

    this.filesDes = [];
    this.filesUpCount = 0;
    this.cargarFilesEn = true;
    this.filesUpCountPor = 0;
    this.router.navigate(['/despachodetalle']);
  }


  async putDetDespacho() {
    console.log('estDesp: ', this.estDesp);
    console.log('imgDesp: ', this.imgDesp);
    console.log('obsDesp: ', this.obsDesp);

    console.log('Enviando datos para cambiar estado de despacho...');
    await this.presentLoading('Enviando datos de despacho...');
    this.apiOnReq = true;

    if (this.estDesp == "Cancelado") { this.despacho.IdEstado = 7;}
    else if (this.estDesp == "Percance") { this.despacho.IdEstado = 6; }
    else if (this.estDesp == "SolicitadoEdit") { this.despacho.IdEstado = 0; }
    
    if (this.despacho.IdEstado == 6) {
      this.despacho.IdEstado = this.estadosDesp.filter(e => e.name == this.estDesp)[0].id;
    }

    let body = {
      iddespacho: this.despacho.Id,
      usr:this.user.Usuario,
      est:this.despacho.IdEstado,
      obs:this.obsDesp,
      img:this.imgDesp
    };
    this.http.post(environment.urlApi + 'putdetdespacho', body).subscribe((res: any) => {
      console.log('putdetdespacho: ',res);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      this.imgDesp = "";
      this.obsDesp = "";
      this.getDespachos();
      this.router.navigate(['/despachospendientes']);
    },
    (err) => {
      console.log('Error http: ', err);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      alert('Error: '+err.body.error.originalError.info.message);
    })

  }


  async loginFun() {
    console.log('Validando credenciales por favor espera...');
    await this.presentLoading('Validando credenciales por favor espera...');
    this.apiOnReq = true;
    let body = {
      usuario: this.usuario.trim(),
      clave:this.clave.trim()
    };
    this.http.post(environment.urlApi + 'loginnewmarket',body).subscribe((res:any)=>{
      console.log('res: ', res);
      if (res.res == "Logeado" && res.usuario.Act) {
        this.login = true;
        this.user = res.usuario;
        if(this.user.LinkDashboard != null){ this.dashboarUser = this.transformUrl(this.user.LinkDashboard) }
        console.log('ssssssssss ', this.user);
        this.getDataDashMk();
        this.router.navigate(['/dashboard']);
        this.presentToast('Bienvenido ' + this.user.Nombres);
        Storage.set({
          key: 'loginMarketDen',
          value: JSON.stringify({user:{Usuario: this.user.Usuario}})
        })
          .then((res) => {
            console.log('informacion de usuario guardada correctamente ', res);
          })
          .catch((err) => {
            console.log('Error al guardar informacion de usuario ', err);
          });
        this.usuario = ""; this.clave = "";
      }
      else {
        if (res.usuario) {
          if(res.usuario.Act){
            alert(res.res);
          }else{
            this.logOut();
            alert('No tienes acceso');
          }
        } else {
          alert(res.res);
        }
      }
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
    })
  }
  
  logOut() {
    /* this.menu.close('end'); */
    this.login = false;
    this.router.navigate(['login']);
    Storage.remove({ key: 'loginMarketDen' }).then(()=>{
      window.location.reload();
    });
  }

  recuperarClave(){
    console.log('correo: ',this.correo);
    console.log('Enviando correo...');
    /* this.presentLoading('Enviando correo...');
    this.apiOnReq = true;
    let body={
      email:this.correo
    };
    this.http.post(environment.urlApi + 'recuperarclavecoorp',body).subscribe((res:any)=>{
      console.log(res);
      this.presentToast(res.res);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
    }) */

  }

  cambiarClave() {
    
  }

  estadosSelectChan(event){
    console.log('estadosSelect: ',event.detail.value);
    this.updateFilter(this.busqueda1);
  }

  estadosDespSelectChan(event){
    console.log('estadosDesSelect: ',event.detail.value);
    this.updateFilter2(this.busqueda2);
  }

  filtDespEstados(){
    let tempFilt=[];
    this.estadosDespSelectValue.forEach(estado => {
      if (estado != "5") {
        const found = this.DespachosFilt.filter(desp => desp.IdEstado == estado);
        tempFilt = tempFilt.concat(found);
      }
    });
    tempFilt.sort((a,b)=> b.IdPedido - a.IdPedido);
    this.DespachosFilt = tempFilt;
    this.totPendDes.tot=0;
    this.totSolicitados.tot=0;
    this.totAceptados.tot=0;
    this.totPercances.tot=0;
    this.totCancelados.tot=0;
    this.DespachosFilt.forEach(desp => {
      desp.estadoDesp = this.estadosDesp.filter(e => e.id == desp.IdEstado)[0];
      desp.metodoPago = this.metodosPago.filter(m => m.id == desp.IdMetodo)[0].name;
      if(desp.IdEstado==0){this.totPendDes.tot = this.totPendDes.tot + 1;}
      if(desp.IdEstado==1){this.totSolicitados.tot = this.totSolicitados.tot + 1;}
      if(desp.IdEstado==2){this.totAceptados.tot = this.totAceptados.tot + 1;}
      if(desp.IdEstado==6){this.totPercances.tot = this.totPercances.tot + 1;}
      if(desp.IdEstado==7){this.totCancelados.tot = this.totCancelados.tot + 1;}
    });
    console.log('DespachosFilt: ',this.DespachosFilt);
  }

  filtPublicEstados(){
    let tempFilt=[];
    this.estadosSelectValue.forEach(estado => {
      const found = this.publicacionesFilt.filter(pub => pub.Estado == estado);
      tempFilt = tempFilt.concat(found);
    });
    tempFilt.sort((a,b)=> b.Id - a.Id);
    this.publicacionesFilt = tempFilt;
    this.totPubActivas=0;
    this.totPubPendRev=0;
    this.totPubInactivas=0;
    this.totPubPendChan=0
    this.publicacionesFilt.forEach(pub => {
      if(pub.Estado==0){ this.totPubInactivas = this.totPubInactivas + 1 }
      if(pub.Estado==1){ this.totPubActivas = this.totPubActivas + 1 }
      if(pub.Estado==2){ this.totPubPendRev = this.totPubPendRev + 1 }
      if(pub.Estado==3){ this.totPubPendChan = this.totPubPendChan + 1 }
    });
    console.log('publicacionesFilt: ',this.publicacionesFilt);
  }
  
  updateFilterHtml(event) {
    this.updateFilter(event.detail.value);
  }

  updateFilter(event) {
    /* const val = event.toLowerCase().trim(); */
    const val = this.sinTildes(event);
    console.log(val);
    // filter our data
    this.publicacionesFilt = this.publicaciones.filter((d) => {
      return (
           this.sinTildes(d.Id).indexOf(val) !== -1
        || this.sinTildes(d.ValorUnt).indexOf(val) !== -1
        || this.sinTildes(d.Titulo).indexOf(val) !== -1
        || this.sinTildes(d.EstadoN).indexOf(val) !== -1
        || this.sinTildes(d.Categoria).indexOf(val) !== -1
        || this.sinTildes(d.Usr).indexOf(val) !== -1
        || this.sinTildes(d.Marca).indexOf(val) !== -1
        || this.sinTildes(d.CodUniversal).indexOf(val) !== -1
        || !val);
    });
    this.filtPublicEstados();
  }

  updateFilterHtml2(event) {
    this.updateFilter2(event.detail.value);
  }

  updateFilter2(event) {
    const val = event.toLowerCase().trim();
    // filter our data
    this.DespachosFilt = this.Despachos.filter((d) => {
      d.Telefono = d.Telefono || "";
      d.Ciudad = d.Ciudad || "";
      return (
          d.Id.toString().indexOf(val) !== -1 
        || d.Producto.toLowerCase().indexOf(val) !== -1  
        || d.Celula.toLowerCase().indexOf(val) !== -1  
        || d.IdPedido.toString().indexOf(val) !== -1  
        || d.estadoDesp.name.toLowerCase().indexOf(val) !== -1  
        || d.NombreCompleto.toLowerCase().indexOf(val) !== -1  
        || d.Telefono.toLowerCase().indexOf(val) !== -1  
        || d.Ciudad.toLowerCase().indexOf(val) !== -1  
        || d.Usr.toLowerCase().indexOf(val) !== -1 
        || d.metodoPago.toLowerCase().indexOf(val) !== -1  
        || d.NumSol.toString().indexOf(val) !== -1 
        || d.Empleador.toLowerCase().indexOf(val) !== -1 
        || !val);
    });
    this.filtDespEstados();
  }

  updateFilterHtml3(event) {
    this.updateFilter3(event.detail.value);
  }

  updateFilter3(event) {
    const val = event.toLowerCase().trim();
    // filter our data
    this.DespachosFilt = this.Despachos.filter((d) => {
      d.Telefono = d.Telefono || "";
      d.Ciudad = d.Ciudad || "";
      return (
        d.Id.toString().indexOf(val) !== -1
        || d.Producto.toLowerCase().indexOf(val) !== -1  
        || d.Celula.toLowerCase().indexOf(val) !== -1  
        || d.IdPedido.toString().indexOf(val) !== -1   
        || d.NombreCompleto.toLowerCase().indexOf(val) !== -1  
        || d.Telefono.toLowerCase().indexOf(val) !== -1  
        || d.Ciudad.toLowerCase().indexOf(val) !== -1  
        || d.Usr.toLowerCase().indexOf(val) !== -1 
        || d.metodoPago.toLowerCase().indexOf(val) !== -1  
        || d.NumSol.toString().indexOf(val) !== -1 
        || d.Empleador.toLowerCase().indexOf(val) !== -1 
        || !val);
    });
    

    let tempFilt=[];
    tempFilt = this.DespachosFilt.filter(desp => desp.IdEstado == 5);
    tempFilt.sort((a,b)=> b.IdPedido - a.IdPedido);
    this.DespachosFilt = tempFilt;
    this.DespachosFilt.forEach(desp => {
      desp.estadoDesp = this.estadosDesp.filter(e => e.id == desp.IdEstado)[0];
      desp.metodoPago = this.metodosPago.filter(m => m.id == desp.IdMetodo)[0].name;
    });
    console.log('DespachosRealizadosFilt: ',this.DespachosFilt);

  }

  
  canConvertToArrayOfObjects(input: string): boolean {
    try {
      const result = JSON.parse(input);
      return Array.isArray(result) && result.every(item => typeof item === 'object');
    } 
    catch (e) {
      return false;
    }
  }


  async getPublicMarket(){
    console.log('Obteniendo Publicaciones...');
    await this.presentLoading('Obteniendo publicaciones...');
    this.apiOnReq = true;
    let body = {
      idrol: this.user.IdRol,
      usr:this.user.Usr
    };
    this.http.post(environment.urlApi + 'getpublicmarket', body, this.HTTPoptions).subscribe((res: any) => {
      console.log('res: ', res);
      res.body.public.forEach(pub => {
        if (!pub.Preguntas) { pub.Preguntas = "[]"; }
        console.log('pub.Id: ', pub.Id);
        console.log('pub.Preguntas: ',pub.Preguntas);
        if(this.canConvertToArrayOfObjects(pub.Preguntas)) {
          pub.Preguntas=JSON.parse(pub.Preguntas)
        }else{
          pub.Preguntas=[
            {
              id: "new",
              name: "",
              valor: '************Es necesario ajustar la descripción. Es posible que hayas utilizado caracteres no permitidos, como las comillas (") u otros caracteres inválidos.****************'
            }
          ]
        }
        pub.UrlFotos=pub.UrlFotos.split('Merka_SSTEC');
        switch (pub.IdCondicion) {
          case 1: pub.Condicion='Nuevo'; break;
          case 2: pub.Condicion='Usado'; break;
          default: pub.Condicion='Sin'; break;
        }
        switch (pub.Estado) {
          case 0: pub.EstadoN='Inactivo'; break;
          case 1: pub.EstadoN='Activo'; break;
          case 2: pub.EstadoN='Pendiente revisión'; break;
          case 3: pub.EstadoN='Pendiente cambios'; break;
          default: pub.EstadoN='Sin'; break;
        }
        const catAux = this.cat.find(c => c.IdCategoria == pub.IdCategoria);
        if (catAux) {
          pub.Categoria = catAux.Nombre;
        } else {
          pub.Categoria = "Inactiva";
        }

        let publicComp = res.body.public_comp.filter(pc => pc.IdProducto == pub.Id)[0] || [];

        pub.VisitasApp=publicComp.VisitasApp || 0; 
        pub.VisitasWeb=publicComp.VisitasWeb || 0; 
        pub.fechaChan=publicComp.fechaChan; 
        pub.fechaPublic=publicComp.fechaPublic;

        pub.Comision=publicComp.Comision; 
        pub.DescDenario=publicComp.DescDenario || 0; 
        pub.DescOtros=publicComp.DescOtros || 0; 
        pub.DescPromo=publicComp.DescPromo || 0; 
        pub.Expo=publicComp.Expo; 
        pub.FechaFinDenario=publicComp.FechaFinDenario || '2000-12-31'; 
        pub.FechaFinOtros=publicComp.FechaFinOtros || '2000-12-31'; 
        pub.FechaFinPromo=publicComp.FechaFinPromo || '2000-12-31'; 
        pub.FechaIniDenario=publicComp.FechaIniDenario || '2000-12-31'; 
        pub.FechaIniOtros=publicComp.FechaIniOtros || '2000-12-31'; 
        pub.FechaIniPromo=publicComp.FechaIniPromo || '2000-12-31'; 
        pub.IVA=publicComp.IVA; 
        pub.PrecioD=publicComp.PrecioD || pub.ValorUnt; 
        pub.PrecioO=publicComp.PrecioO || pub.ValorUnt; 
        pub.StockAlert=publicComp.StockAlert; 
        pub.StockCong=publicComp.StockCong; 
        pub.StockPRH=publicComp.StockPRH; 
        pub.UserCre=publicComp.UserCre; 
        pub.UserChan=publicComp.UserChan; 
        pub.UserPublic = publicComp.UserPublic; 
        pub.Peso = publicComp.Peso || 2;
        pub.ValDecInterr = publicComp.ValDecInterr || 15000; 
        pub.DimensionStr = publicComp.Dimension || "10,10,10"
      });
      this.publicaciones=res.body.public;
      this.publicacionesFilt=res.body.public;
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      this.updateFilter(this.busqueda1);
    },
    (err) => {
      console.log('Error http: ', err);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      alert('Error: '+err.error.originalError.info.message);
    })
  }



  async getAllCategorias(){
    console.log('Obteniendo todas las categorias...');
    let body = {};
    this.http.post(environment.urlApi + 'getallcategorias',body).subscribe((res:any)=>{
      console.log('getAllCategorias: ',res);
      this.cat=res.cat;
      this.cat1=res.cat1;
      this.cat2=res.cat2;
      this.cat3=res.cat3;
      /* this.getPublicMarket(); */
    });
  }

  categoriaChan(ca){
    this.cat1Select=[];this.producto.Cat1="";
    this.cat2Select=[];this.producto.Cat2="";
    this.cat3Select=[];this.producto.Cat3="";
    this.producto.IdCategoria=ca.detail.value;
    this.cat1Select = this.cat1.filter(c => c.IdBoton == this.producto.IdCategoria);
    console.log('cat1Select: ',this.cat1Select)
    this.producto.categoria = this.cat.filter(c => c.IdCategoria == this.producto.IdCategoria)[0];
    this.clipBoard="";
    this.clipBoard=this.producto.IdCategoria.toString();
  }

  categoria1Chan(ca){
    this.cat2Select=[];this.producto.Cat2="";
    this.cat3Select=[];this.producto.Cat3="";
    this.producto.Cat1=ca.detail.value;
    this.cat2Select = this.cat2.filter(c => c.IdCat1 == this.producto.Cat1);
    console.log('cat2Select: ',this.cat2Select)
    this.clipBoard="";
    this.clipBoard=this.producto.IdCategoria+","+this.producto.Cat1;
  }

  categoria2Chan(ca){
    this.cat3Select=[];this.producto.Cat3="";
    this.producto.Cat2=ca.detail.value;
    this.cat3Select = this.cat3.filter(c => c.IdCat2 == this.producto.Cat2);
    console.log('cat3Select: ',this.cat3Select)
    this.clipBoard="";
    this.clipBoard=this.producto.IdCategoria+","+this.producto.Cat1+","+this.producto.Cat2;
  }

  categoria3Chan(ca){
    this.producto.Cat3=ca.detail.value;
    this.clipBoard="";
    this.clipBoard=this.producto.IdCategoria+","+this.producto.Cat1+","+this.producto.Cat2+","+this.producto.Cat3;
  }


  
  categoriaChanNew(ca){
    this.cat1Select=[];this.IdCat1=null;
    this.cat2Select=[];this.IdCat2=null;
    this.cat3Select=[];this.IdCat3=null;
    this.cat1Select = this.cat1.filter(c => c.IdBoton == ca.detail.value);
    this.IdCatObj = this.cat.filter(c => c.IdCategoria==this.IdCat)[0];
    console.log('cat1Select: ',this.cat1Select);
    console.log('IdCat: ',this.IdCat);
    console.log('IdCatObj: ',this.IdCatObj);
  }

  categoria1ChanNew(ca){
    this.cat2Select=[];this.IdCat2=null;
    this.cat3Select=[];this.IdCat3=null;
    this.cat2Select = this.cat2.filter(c => c.IdCat1 == ca.detail.value);
    this.IdCat1Obj = this.cat1.filter(c => c.IdCat1==this.IdCat)[0];
    console.log('cat2Select: ',this.cat2Select);
    console.log('IdCat1: ',this.IdCat1);
    console.log('IdCat1Obj: ',this.IdCat1Obj);
  }

  categoria2ChanNew(ca){
    this.cat3Select=[];this.IdCat3=null;
    this.cat3Select = this.cat3.filter(c => c.IdCat2 == ca.detail.value);
    this.IdCat2Obj = this.cat2.filter(c => c.IdCat2==this.IdCat)[0];
    console.log('cat3Select: ',this.cat3Select);
    console.log('IdCat2: ',this.IdCat2);
    console.log('IdCat2Obj: ',this.IdCat2Obj);
  }

  categoria3ChanNew(ca){
    this.IdCat3Obj = this.cat3.filter(c => c.IdCat3==this.IdCat)[0];
    console.log('categoria3ChanNew: ',ca.detail.value);
    console.log('IdCat3: ',this.IdCat3);
    console.log('IdCat3Obj: ',this.IdCat3Obj);
  }  



  comparaObj() {
    if (JSON.stringify(this.producto) === this.productoPre) { return false; }
    else { return true;}
  }

  estPublicChan(est) {
    console.log('estado: ', est.detail.value);
  }

  addDescrip() {
    this.producto.Preguntas.push({
      id: "new",
      name: "",
      valor:""
    })
  }

  procuctoEstadoChan(event) {
    this.producto.Estado=event.detail.value
  }

  resProducto() {
    if (JSON.stringify(this.producto) != this.productoPre && !this.isProductNew) {
      this.publicaciones = JSON.parse(this.publicacionesPre);
      this.updateFilter(this.busqueda1);
      console.log('publicaciones restauradas');
    }
  }

  deleteDescirp(des) {
    console.log('deleteDescirp: ', des);
    this.producto.Preguntas.splice(des, 1);
    this.changeDescLength();
  }

  changeDescLength() {
    this.producto.PreguntasLength = JSON.stringify(this.producto.Preguntas).length;
    if (this.producto.PreguntasLength > 3900) {
      this.presentToast('La descripción no pude superar los 3900 caracteres');
    }
  }

  chanPublic() {
    console.log('producto: ', this.producto);
    let productToDB = JSON.parse(JSON.stringify(this.producto));
    if (productToDB.Cat1) { productToDB.Categorias = productToDB.Cat1;}
    if (productToDB.Cat2) { productToDB.Categorias = productToDB.Categorias+","+productToDB.Cat2;}
    if (productToDB.Cat3) { productToDB.Categorias = productToDB.Categorias + "," + productToDB.Cat3; }
    productToDB.Preguntas = JSON.stringify(productToDB.Preguntas);
    productToDB.UrlFotos = this.producto.UrlFotos[0];
    for (let i = 1; i < this.producto.UrlFotos.length; i++){
      productToDB.UrlFotos = productToDB.UrlFotos + "Merka_SSTEC" + this.producto.UrlFotos[i];
    }
    console.log('productToDB: ', productToDB);
  }

  async putPublicMarket(productToDB){
    console.log('Creando Publicacion...');
    await this.presentLoading('Creando publicación...');
    this.apiOnReq = true;
    let body = {
      public: productToDB,
    };
    this.http.post(environment.urlApi + 'putpublicacionmk', body).subscribe((res: any) => {
      console.log('putPublicMarket: ', res);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      this.producto = [];
      this.router.navigate(['/publicaciones']);
      this.getPublicMarket();
    },
    (err) => {
      console.log('Error http: ', err);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      alert('Error: '+err.error.res);
    })
  }

  async uploadPublicMarket(productToDB){
    console.log('Creando Publicacion...');
    await this.presentLoading('Actualizando publicación...');
    this.apiOnReq = true;
    let body = {
      public: productToDB,
    };
    this.http.post(environment.urlApi + 'uploadpublicacionmk', body).subscribe((res: any) => {
      console.log('uploadPublicMarket: ', res);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      this.producto = [];
      this.router.navigate(['/publicaciones']);
      this.getPublicMarket();
    },
    (err) => {
      console.log('Error http: ', err);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      alert('Error: '+err.error.body.originalError.info.message);
    })
  }

  async uploadPublicMarket2(productToDB){
    console.log('Creando Publicacion...');
    await this.presentLoading('Actualizando publicación...');
    this.apiOnReq = true;
    let body = {
      public: productToDB,
    };
    this.http.post(environment.urlApi + 'uploadpublicacionmk2', body).subscribe((res: any) => {
      console.log('uploadPublicMarket: ', res);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      this.producto = [];
      this.router.navigate(['/publicaciones']);
      this.getPublicMarket();
    },
    (err) => {
      console.log('Error http: ', err);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      this.presentAlert('Error al actualizar', "", err.error.res);
      /* alert('Error: '+err.error.body.originalError.info.message); */
    })
  }

  async uploadPublicMarket3(productToDB){
    console.log('Actualizando Publicacion...');
    await this.presentLoading('Actualizando publicación...');
    this.apiOnReq = true;
    let body = {
      public: productToDB,
    };
    this.http.post(environment.urlApi + 'uploadpublicacionmk3', body).subscribe((res: any) => {
      console.log('uploadPublicMarket: ', res);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      this.producto = [];
      this.router.navigate(['/publicaciones']);
      this.getPublicMarket();
    },
    (err) => {
      console.log('Error http: ', err);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      alert('Error: '+err.error.body.originalError.info.message);
    })
  }

  crearPublic() {
    console.log('producto: ', this.producto);
    this.producto.Usr = this.user.Usr;
    if ( this.producto.Titulo && this.producto.Cantidad && this.producto.CodUniversal && this.producto.IdCondicion && this.producto.Stock!=null && this.producto.Marca && this.producto.UrlFotos.length>0 && this.producto.ValorUnt!=null && this.producto.Usr && this.producto.Estado && this.producto.Preguntas.length>0 && this.producto.IVA!=null && this.producto.Comision!=null && this.producto.StockPRH!=null) {
      let productToDB = JSON.parse(JSON.stringify(this.producto));
      if (productToDB.Cat1) { productToDB.Categorias = productToDB.Cat1;}
      if (productToDB.Cat2) { productToDB.Categorias = productToDB.Categorias+","+productToDB.Cat2;}
      if (productToDB.Cat3) { productToDB.Categorias = productToDB.Categorias + "," + productToDB.Cat3; }
      productToDB.Preguntas = JSON.stringify(productToDB.Preguntas);
      productToDB.UrlFotos = this.producto.UrlFotos[0];
      for (let i = 1; i < this.producto.UrlFotos.length; i++){
        productToDB.UrlFotos = productToDB.UrlFotos + "Merka_SSTEC" + this.producto.UrlFotos[i];
      }
      productToDB.Usuario = this.user.Usuario;
      productToDB.StockAlert = 30;
      productToDB.StockCong = 10;
      productToDB.DimensionStr = `${this.producto.Dimension.Ancho || 10},${this.producto.Dimension.Alto || 10},${this.producto.Dimension.Largo || 10}`;
      console.log('productToDB: ', productToDB);
      this.putPublicMarket(productToDB);
    } else {
      this.presentAlert('Error', 'Al crear publicación', 'Los campos que inician con * son obligatorios');
    }
  }

  async crearPublicMas(){
    console.log('productosToUpMas: ',this.productosToUpMas)
    this.apiOnReq=true;
    this.publicUpN = 0;
    this.publicUpP = 0;
    let publicError = [];
    for(let prod of this.productosToUpMas) { 
      if ( 
           prod.Titulo
        && prod.Cantidad
        && prod.CodUniversal
        && prod.IdCondicion
        && prod.Stock
        && prod.Marca
        && prod.UrlFotos.length > 0
        && prod.ValorUnt
        && prod.Usr
        && prod.Estado
        && prod.Preguntas.length > 0
        && this.producto.IVA != null
        && this.producto.Comision != null
        && this.producto.StockPRH != null) {
        let productToDB = JSON.parse(JSON.stringify(prod));
        if (productToDB.Cat1) { productToDB.Categorias = productToDB.Cat1;}
        if (productToDB.Cat2) { productToDB.Categorias = productToDB.Categorias+","+productToDB.Cat2;}
        if (productToDB.Cat3) { productToDB.Categorias = productToDB.Categorias + "," + productToDB.Cat3; }

        productToDB.Preguntas.forEach(pregunta => { pregunta.valor = this.sqlAdapt(pregunta.valor); });
        productToDB.Preguntas = JSON.stringify(productToDB.Preguntas);
        productToDB.Titulo = this.sqlAdapt(productToDB.Titulo);
        productToDB.Modelo = this.sqlAdapt(productToDB.Modelo);
        productToDB.Marca = this.sqlAdapt(productToDB.Marca);

        productToDB.UrlFotos = prod.UrlFotos[0];
        for (let i = 1; i < prod.UrlFotos.length; i++){
          productToDB.UrlFotos = productToDB.UrlFotos + "Merka_SSTEC" + prod.UrlFotos[i];
        }
        productToDB.Usuario = this.user.Usuario;
        productToDB.StockAlert = 30;
        productToDB.StockCong = 10;
        /* productToDB.DimensionStr = `${productToDB.Dimension.Ancho || 10},${productToDB.Dimension.Alto || 10},${productToDB.Dimension.Largo || 10}`; */
        console.log('productToDB: ', productToDB);
        
        /* ***** */

        let putpub = new Promise ((res,rej)=>{
          let body = {
            public: productToDB,
          };
          this.http.post(environment.urlApi + 'putpublicacionmk', body).subscribe((resp: any) => {
              console.log('putPublicMarket: ', resp);
              this.publicUpN = this.publicUpN + 1;
              this.publicUpP = this.publicUpN/this.productosToUpMas.length;
              res('ok');
            },
            (err) => {
              console.log('Error http: ', err);
              publicError.push({
                Titulo:productToDB.Titulo,
                CodUniversal:productToDB.CodUniversal,
                error: JSON.stringify(err)
              })
              res('fail');
            })
        })

        await putpub;
        
        /* ***** */
        
      } else {
        /* this.presentAlert('Error', 'Al crear publicación ' + prod.Titulo, 'Los campos que inician con * son obligatorios'); */
        console.log('Error Al crear publicación masiva: ', 'Los campos que inician con * son obligatorios');
        publicError.push({
          Titulo:prod.Titulo,
          CodUniversal:prod.CodUniversal,
          error: 'Los campos que inician con * son obligatorios'
        })
      }
    };
    this.apiOnReq=false;
    this.producto = [];
    this.router.navigate(['/publicaciones']);
    this.getPublicMarket();
    if(publicError.length>0){
      let titulos = "";
      publicError.forEach(ti => {
        titulos=titulos + " ** "+ti.Titulo+"-"+ti.CodUniversal
      });
      this.exportAsExcelFile(publicError,'errorsPublic');
      this.presentAlert('Error en publicación masiva','Problema al cargar la(s) siguiente(s) publicacion(es) (más información en el archivo errorsPublic.xlsx): ',JSON.stringify(titulos));
    }
  }

  chanPublicApi() {
    console.log('producto chan: ', this.producto);
    if (this.user.Usr) { this.producto.Usr = this.user.Usr };
    if ( this.producto.Titulo && this.producto.Cantidad && this.producto.CodUniversal && this.producto.IdCondicion && this.producto.Stock!=null && this.producto.Marca && this.producto.UrlFotos.length>0 && this.producto.ValorUnt!=null && this.producto.Usr && this.producto.Preguntas.length>0 && this.producto.IVA!=null && this.producto.Comision!=null && this.producto.StockPRH!=null) {
      let productToDB = JSON.parse(JSON.stringify(this.producto));
      if (productToDB.Cat1) { productToDB.Categorias = productToDB.Cat1;}
      if (productToDB.Cat2) { productToDB.Categorias = productToDB.Categorias+","+productToDB.Cat2;}
      if (productToDB.Cat3) { productToDB.Categorias = productToDB.Categorias + "," + productToDB.Cat3; }
      productToDB.Preguntas = JSON.stringify(productToDB.Preguntas);
      productToDB.UrlFotos = this.producto.UrlFotos[0];
      for (let i = 1; i < this.producto.UrlFotos.length; i++){
        productToDB.UrlFotos = productToDB.UrlFotos + "Merka_SSTEC" + this.producto.UrlFotos[i];
      }
      productToDB.Usuario = this.user.Usuario;
      productToDB.DimensionStr = `${this.producto.Dimension.Ancho},${this.producto.Dimension.Alto},${this.producto.Dimension.Largo}`;
      console.log('productToDB: ', productToDB);
      this.uploadPublicMarket(productToDB);
    } else {
      this.presentAlert('Error', 'Al actualizar publicación', 'Los campos que inician con * son obligatorios');
    }
  }

  chanPublicApi2() {
    console.log('producto chan: ', this.producto);
    if (this.user.Usr) { this.producto.Usr = this.user.Usr };
    if ( this.producto.Titulo && this.producto.Cantidad && this.producto.CodUniversal && this.producto.IdCondicion && this.producto.Stock!=null && this.producto.Marca && this.producto.UrlFotos.length>0 && this.producto.ValorUnt!=null && this.producto.Usr && this.producto.Preguntas.length>0 && this.producto.IVA!=null && this.producto.Comision!=null && this.producto.StockPRH!=null) {
      let productToDB = JSON.parse(JSON.stringify(this.producto));
      if (productToDB.Cat1) { productToDB.Categorias = productToDB.Cat1;}
      if (productToDB.Cat2) { productToDB.Categorias = productToDB.Categorias+","+productToDB.Cat2;}
      if (productToDB.Cat3) { productToDB.Categorias = productToDB.Categorias + "," + productToDB.Cat3; }
      productToDB.Preguntas = JSON.stringify(productToDB.Preguntas);
      productToDB.UrlFotos = this.producto.UrlFotos[0];
      for (let i = 1; i < this.producto.UrlFotos.length; i++){
        productToDB.UrlFotos = productToDB.UrlFotos + "Merka_SSTEC" + this.producto.UrlFotos[i];
      }
      productToDB.Usuario = this.user.Usuario;
      productToDB.DimensionStr = `${this.producto.Dimension.Ancho},${this.producto.Dimension.Alto},${this.producto.Dimension.Largo}`;
      console.log('productToDB: ', productToDB);
      this.uploadPublicMarket2(productToDB);
    } else {
      this.presentAlert('Error', 'Al actualizar publicación', 'Los campos que inician con * son obligatorios');
    }
  }

  chanPublicApi3() {
    console.log('producto chan: ', this.producto);
    if (this.user.Usr) { this.producto.Usr = this.user.Usr };
    if ( this.producto.Titulo && this.producto.Cantidad && this.producto.CodUniversal && this.producto.IdCondicion && this.producto.Stock!=null && this.producto.Marca && this.producto.UrlFotos.length>0 && this.producto.ValorUnt!=null && this.producto.Usr && this.producto.Preguntas.length>0 && this.producto.IVA!=null && this.producto.Comision!=null && this.producto.StockPRH!=null) {
      let productToDB = JSON.parse(JSON.stringify(this.producto));
      if (productToDB.Cat1) { productToDB.Categorias = productToDB.Cat1;}
      if (productToDB.Cat2) { productToDB.Categorias = productToDB.Categorias+","+productToDB.Cat2;}
      if (productToDB.Cat3) { productToDB.Categorias = productToDB.Categorias + "," + productToDB.Cat3; }
      productToDB.Preguntas = JSON.stringify(productToDB.Preguntas);
      productToDB.UrlFotos = this.producto.UrlFotos[0];
      for (let i = 1; i < this.producto.UrlFotos.length; i++){
        productToDB.UrlFotos = productToDB.UrlFotos + "Merka_SSTEC" + this.producto.UrlFotos[i];
      }
      productToDB.Usuario = this.user.Usuario;
      productToDB.DimensionStr = `${this.producto.Dimension.Ancho},${this.producto.Dimension.Alto},${this.producto.Dimension.Largo}`;
      console.log('productToDB: ', productToDB);
      this.uploadPublicMarket3(productToDB);
    } else {
      this.presentAlert('Error', 'Al actualizar publicación', 'Los campos que inician con * son obligatorios');
    }
  }

  async chanPublicApi3Alert(){
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Confirma!',
      message: 'Solo los cambios en Estado, Precio, Stock, imágenes y Descripción tendrán efecto',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Confirmar',
          handler: () => {
            this.chanPublicApi3();
          }
        }
      ]
    });

    await alert.present();
  }

  async setSolChanPuplic(cambios){
    console.log('Enviando solicitud de cambios...');
    await this.presentLoading('Enviando solicitud de cambios...');
    this.apiOnReq = true;
    let body = {
      sol: {
        Id: this.producto.Id,
        Cambios: cambios
      }
    };
    this.http.post(environment.urlApi + 'setsolchanpuplic', body).subscribe((res: any) => {
      console.log('setsolchanpuplic: ', res);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      this.getPublicMarket();
      this.router.navigate(['/publicaciones']);
      this.producto = [];
    },
    (err) => {
      console.log('Error http: ', err);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      alert('Error: '+err.body.error.originalError.info.message);
    })
  }

  async solChanges() {

    const alert = await this.alertController.create({
      cssClass: 'alertChanges',
      header: 'Lista de cambios',
      inputs: [
        // multiline input.
        {
          name: 'chan',
          id: 'chan',
          type: 'textarea',
          cssClass:'textareaChan',
          placeholder: 'Solicitud de cambios',
          value: this.producto.SolCambios
        }
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Enviar',
          handler: (res) => {
            console.log('Confirm Ok: ', res.chan);
            this.setSolChanPuplic(res.chan);
          }
        }
      ]
    });

    await alert.present();
    
  }

  async verChanges() {

    const alert = await this.alertController.create({
      cssClass: 'alertChanges',
      header: 'Lista de cambios',
      inputs: [
        // multiline input.
        {
          name: 'chan',
          id: 'chan',
          type: 'textarea',
          cssClass:'textareaChan',
          placeholder: 'Solicitud de cambios',
          value: this.producto.SolCambios
        }
      ],
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }
      ]
    });

    await alert.present();
    
  }

  async publicPuplic(){
    console.log('Publicando...');
    await this.presentLoading('Publicando...');
    this.apiOnReq = true;
    let body = {
      Id: this.producto.Id,
      Usuario: this.user.Usuario
    };
    this.http.post(environment.urlApi + 'publicpublic', body).subscribe((res: any) => {
      console.log('publicpublic: ', res);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      this.producto = [];
      this.router.navigate(['/publicaciones']);
      this.getPublicMarket();
    },
    (err) => {
      console.log('Error http: ', err);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      alert('Error: '+err.body.error.originalError.info.message);
    })
  }


  async publicAlert() {

    const alert = await this.alertController.create({
      header: 'Confirma',
      subHeader:'La publicación será visible en el market',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Publicar',
          handler: (res) => {
            console.log('Confirm Ok: ');
            this.publicPuplic();
          }
        }
      ]
    });

    await alert.present();
    
  }

  async deletePuplic(){
    console.log('Eliminando...');
    await this.presentLoading('Eliminando...');
    this.apiOnReq = true;
    let body = {
      Id: this.producto.Id
    };
    this.http.post(environment.urlApi + 'deletepublic', body).subscribe((res: any) => {
      console.log('deletepublic: ', res);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      this.producto = [];
      this.router.navigate(['/publicaciones']);
      this.getPublicMarket();
    },
    (err) => {
      console.log('Error http: ', err);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      alert('Error: '+err.body.error.originalError.info.message);
    })
  }


  async deletePublicAlert() {

    const alert = await this.alertController.create({
      header: 'Confirma',
      subHeader:'La publicación será eliminada',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Eliminar',
          handler: (res) => {
            console.log('Confirm Ok: ');
            this.deletePuplic();
          }
        }
      ]
    });

    await alert.present();
    
  }


  /* async vistaPre() {
    const popover = await this.popoverController.create({
      component: VistaprePage,
      cssClass: 'popoverStyle',
      translucent: true,
      componentProps: {},
      mode:'ios'
    });
    return await popover.present();
  } */



  async publicMasivaPop() {
    this.producto = this.productoMasivo;
    const popover = await this.popoverController.create({
      component: NewmasivadownloadPage,
      cssClass: 'popoverStyle2',
      /* event: ev, */
      translucent: true,
      componentProps: {},
      mode:'ios'
    });
    return await popover.present();
  }

  downloadPlantillaMasiva() {
    console.log('producto: ', this.producto);
    delete this.producto.categoria;
    let productos = [];
    productos.push(this.producto);
    this.exportAsExcelFile(productos, 'PlantillaMasiva');
    /* if (this.producto.IdCategoria) {
    } else {
      this.presentAlert('Error', 'Al descargar plantilla', 'Los campos que inician con * son obligatorios');
    } */
  }

  onFileChange(ev) {
    console.log('filePublicMas: ',this.filePublicMas)
    console.log('Event: ',ev);
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev.target.files[0];
    reader.onload = (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});
      console.log('DataJson: ', jsonData);
      if (jsonData.PlantillaMasiva) {
        this.productosToUpMas = jsonData.PlantillaMasiva;
        this.productosToUpMas.forEach(prod => {
          prod.Preguntas = prod.Descripcion;
          if(prod.CodUniversal!=null){prod.CodUniversal=prod.CodUniversal.toString()}
          if(prod.Titulo!=null){prod.Titulo=prod.Titulo.toString()}
          if(prod.Marca!=null){prod.Marca=prod.Marca.toString()}
          if(prod.Modelo!=null){prod.Modelo=prod.Modelo.toString()}
          if(prod.FechaIniPromo!=null){prod.FechaIniPromo="2000-12-31"}
          if(prod.FechaFinPromo!=null){prod.FechaFinPromo="2000-12-31"}
          if(prod.DescPromo!=null){prod.DescPromo=0}
          if(prod.StockPRH!=null){prod.StockPRH=50}
          prod.StockAlert=20;
          prod.StockCong=10;
          prod.DescDenario=0;
          prod.FechaIniDenario='2000-12-31';
          prod.FechaFinDenario='2000-12-31';
          prod.DescOtros=0;
          prod.FechaIniOtros='2000-12-31';
          prod.FechaFinOtros='2000-12-31';
          prod.Usr=this.user.Usr;
          prod.Categorias="";
          if (prod.Cat1) { prod.Categorias = prod.Cat1.toString();}
          if (prod.Cat2) { prod.Categorias = prod.Categorias+","+prod.Cat2;}
          if (prod.Cat3) { prod.Categorias = prod.Categorias + "," + prod.Cat3; }
          prod.Cantidad= 1;
          let catArr = this.cat.filter(c => c.IdCategoria == prod.IdCategoria)[0];
          if(catArr){ prod.Categoria = catArr.Nombre; }else{ this.presentAlert('Error en plantilla', 'Categoría invalida '+prod.IdCategoria, prod.Titulo+' - '+prod.CodUniversal) }
          switch (prod.Condicion.toLowerCase()) {
            case 'nuevo': prod.IdCondicion=1; break;
            case 'usado': prod.IdCondicion=2; break;
            default: prod.IdCondicion=1; break;
          }
          prod.Estado= 2;
          prod.EstadoN= "Pendiente revisión";
          prod.IdColor = 1;
          if (prod.Preguntas) {
            let pregArray = prod.Preguntas.split(",,");
            prod.Preguntas = [];
            pregArray.forEach(preg => {
              prod.Preguntas.push({
                id: 'new',
                name: "",
                valor:preg
              })
            });
          } else {
            this.presentAlert("Error al subir plantilla","Campo Preguntas vacio","el producto "+prod.Titulo+" no tiene preguntas.")
          }

          if (prod.UrlFotos) {
            prod.UrlFotos = prod.UrlFotos.split(",,");
          } else {
            this.presentAlert("Error al subir plantilla","Campo UrlFotos vacio","el producto "+prod.Titulo+" no tiene fotos.")
          }
          /* prod.Dimension = {
            Ancho: prod.Ancho,
            Alto: prod.Alto,
            Largo: prod.Largo
          }; */
          prod.DimensionStr = `${prod.Ancho || 10},${prod.Alto || 10},${prod.Largo || 10}`;
        });
        console.log('productosToUpMas: ', this.productosToUpMas);
        this.popoverController.dismiss()
        this.router.navigate(['showproductsmas']);
      } else {
        this.presentAlert("Error al subir plantilla", "nombre de hoja de calculo", "Por favor cambia el nombre de la hoja de excel a PlantillaMasiva");
      }
    }
    reader.readAsBinaryString(file);
  }



  async getDataDashMk(){
    console.log('Cargando datos de dashboard...');
    /* await this.presentLoading('Cargando datos de dashboard...');
    this.apiOnReq = true; */
    let body = {
      rol: this.user.IdRol,
      usr: this.user.Usr
    };
    this.http.post(environment.urlApi + 'getdatadashMk', body).subscribe((res: any) => {
      console.log('getdatadashMk: ', res.body[0]);
      this.ppr = res.body[0].ppr;
      this.ppc = res.body[0].ppc;
      this.dp = res.body[0].dp;
      this.getAllCategorias();
      /* this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador); */
    },
    (err) => {
      console.log('Error http: ', err);
      /* this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador); */
      alert('Error: '+err.error.body.originalError.info.message);
    })
  }

  async getDespachos(){
    console.log('Cargando datos de dashboard...');
    await this.presentLoading('Cargando datos de despacho...');
    this.apiOnReq = true;
    let body = {
      rol: this.user.IdRol,
      usr: this.user.Usr
    };
    this.http.post(environment.urlApi + 'getdespachos', body).subscribe((res: any) => {
      console.log('res: ', res.body);
      let filtRes = [];
      if(this.user.IdRol == 100){
        res.body.forEach(r => {
          filtRes.push(r);
        });
      }else{
        res.body.forEach(r => {
          if(r.IdEstado!=0){
            filtRes.push(r);
          }
        });
      }

      filtRes.forEach(desp => {
        desp.estadoDesp = this.estadosDesp.filter(e => e.id == desp.IdEstado)[0];
        desp.metodoPago = this.metodosPago.filter(m => m.id == desp.IdMetodo)[0].name;
        desp.linkProd = "https://denario.com.co/App/store.html#" + desp.IdProducto;
        desp.UrlfotoP = desp.UrlfotoP.split('Merka_SSTEC')[0];
        if (desp.PrecioBase != desp.PrecioUnit){ desp.DIF = 1; } else { desp.DIF = 0; }
        /* let productComp = this.publicaciones.filter(p => p.Id==desp.IdProducto)[0];
        if(productComp){
          desp.Sku = productComp.CodUniversal;
          desp.Producto = productComp.Titulo;
          desp.UrlfotoP = productComp.UrlFotos[0];
        } */
      });

      console.log('getdespachos: ', filtRes);
      this.Despachos = filtRes;
      this.DespachosFilt = filtRes;
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      console.log('router: ', this.router.url);
      if (this.router.url== "/despachospendientes"){ this.updateFilter2(this.busqueda2); }
      if (this.router.url== "/despachosrealizados"){ this.updateFilter3(this.busqueda3); }
    },
    (err) => {
      console.log('Error http: ', err);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      alert('Error: '+err.error.body.originalError.info.message);
    })
  }

  async sendSmsDatosDesp(desp){
    console.log('Desp: ',desp);

    console.log('Reenviando mensaje para datos de despacho...');
    await this.presentLoading('Reenviando mensaje para datos de despacho...');
    this.apiOnReq = true;
    let body = {
      cedula:desp.Celula.trim(),
      idpedido:desp.IdPedido,
      telefono:desp.TelefonoReg.trim(),
      nombre:desp.NombreCompleto,
      medioPago:desp.metodoPago,
      total:desp.PrecioTotal,
      producto:desp.Producto,
      cantidad:desp.Qty,
      correo:desp.CorreoReg
    };
    this.http.post(environment.urlApi + 'SendSmsFormMk2', body).subscribe((res: any) => {
      console.log('SendSmsFormMk2: ',res);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
    },
    (err) => {
      console.log('Error http: ', err);
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      alert('Error: '+err.body.error.originalError.info.message);
    });
  }

  async popChanEstDesp(est){
    this.estDesp=est;
    console.log('estDesp: ',this.estDesp);
    this.router.navigate(['/chanestdesp']);
    /* const popover = await this.popoverController.create({
      component: ChanestdespPage,
      cssClass: 'popoverStyle3',
      translucent: true,
      componentProps: {},
      mode:'ios'
    });
    return await popover.present(); */
  }

  cancelarChanEstDesp() {
    this.obsDesp = "";
    this.filesDes = [];
    this.router.navigate(['/despachodetalle']);
  }
  /* async CopyClipCat(){
    console.log("clipBoard: ",this.clipBoard);
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.clipBoard;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  } */

  async CopyClipCat(){
    console.log("clipBoard: ",this.clipBoard);
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = "Hola\tDavid"
    let cat1,cat2,cat3
    if(this.producto.Cat1==null){cat1="";}else{cat1=this.producto.Cat1;}
    if(this.producto.Cat2==null){cat2="";}else{cat2=this.producto.Cat2;}
    if(this.producto.Cat3==null){cat3="";}else{cat3=this.producto.Cat3;}
    selBox.value = this.producto.IdCategoria+"\t"+cat1+"\t"+cat2+"\t"+cat3;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.presentToast("Categorías copiadas en el portapapeles");
  }

  formatoChallenger() {
    console.log('DespachosFilt: ', this.DespachosFilt);
    let docChallenger = [];
    this.DespachosFilt.forEach(d => {
      d.fechaEnt = new Date(this.datePipe.transform(d.FechaSol, "yyy-MM-dd", "+0000"));
      d.fechaEnt = d.fechaEnt.setDate(d.fechaEnt.getDate() + 5);
      docChallenger.push({
        IdDenario: d.Id,
        Formato:`H|CO0000003|E-COMM|120|${this.datePipe.transform(d.FechaSol, "ddMMyyy", "+0000")}|${this.datePipe.transform(d.fechaEnt, "ddMMyyy", "+0000")}|COP|${d.NombreCompleto}/${d.Celula}/${d.Ciudad}/${d.Direccion}/${d.Telefono}|1|CM0000001|${d.Id}|V010|222|DENARIO|222|V03010|juanfra.reyes@denario.com.co|D|1|${d.Sku}|${d.Qty}|${(d.PrecioUnit/1.19).toFixed(2)}||0|000`
      })
    });
    console.log('docChallenger: ', docChallenger);
    this.exportAsExcelFile(docChallenger, "FormatoDespChallenger");
  }

  /* PLANTILLA MASIVA GENERAL */

  downloadPlantillaPublicMasiva() {
    console.log('publicaciones: ', this.publicaciones);
    let plantilla = [];
    plantilla.push({
        Id: "(No editable)"
      , SKU: "(No editable)"
      , Titulo: "(No editable)"
      , Stock: "(*) (Numero entero)"
      , PrecioPublic: "(*) (Precio IVA incluido)"
      , IVA: "(*) (%)"
      , ComisionDenario: "(*) (%)"
      , DescuentoPromo: "(%)"
      , FechaIniPromo: "(Fecha en formato YYY-MM-DD)"
      , FechaFinPromo: "(Fecha en formato YYY-MM-DD)"
      , Estado: "(*) (0:Inactivo, 1:Activo)"
      , Peso: "valor en Kg mínimo 1Kg"
      , ValDecInterr: "valor mínimo $15.000"
      , Dimension: "Largo,Ancho,Alto (cm)"
      , Descripcion: '(*) (Cada descripción separada por doble coma ",,")'
    });
    this.publicaciones.forEach(p => {
      let descripcion = "";
      p.Preguntas.forEach((d,i)=> {
        descripcion = descripcion + d.valor;
        if (p.Preguntas.length > (i+1)) { descripcion = descripcion + ",,";}
      });
      plantilla.push({
        Id: p.Id
        , SKU: p.CodUniversal
        , Titulo: p.Titulo
        , Stock: p.Stock
        , PrecioPublic: p.ValorUnt
        , IVA: p.IVA
        , ComisionDenario: p.Comision
        , DescuentoPromo: p.DescPromo
        , FechaIniPromo: p.FechaIniPromo
        , FechaFinPromo: p.FechaFinPromo
        , Estado: p.Estado
        , Peso: p.Peso 
        , Dimension: p.DimensionStr
        , ValDecInterr: p.ValDecInterr
        , Descripcion: descripcion
      });
    });
    console.log('plantilla: ', plantilla);
    this.exportAsExcelFile(plantilla, 'PlantillaPublicMas');
  }

  async onFileChangeMas(ev) {
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev.target.files[0];
    reader.onload = async (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});
      /* console.log('DataJson: ', jsonData); */
      if (jsonData.PlantillaPublicMas) {
        this.onFileChangeMasAlert(jsonData.PlantillaPublicMas);
      } else {
        this.presentAlert("Error al subir plantilla", "Nombre de hoja de calculo", "Por favor cambia el nombre de la hoja de excel a PlantillaPublicMas");
      }
    }
    reader.readAsBinaryString(file);
  }


  async onFileChangeMasAlert(plantilla: any) {
    this.plantillaLength = plantilla.length;
    const alert = await this.alertController.create({
      mode:'ios',
      header: 'Confirma!',
      message: '<strong>Actualizaciones: </strong>'+(this.plantillaLength-1),
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Confirmar',
          handler: () => {
            console.log('Confirm Okay');
            if (!this.showLoad) {
              this.uploadActMasGen(plantilla);
            } else {
              this.presentToast('Por favor espera...');
            }
          }
        }
      ]
    });
    await alert.present();
  }

  sqlAdapt(input: string) {
    let out = input.toString();
    out = out.replace(/"/gi, "``").toString();
    out = out.replace(/'/gi, "`").toString();
    out = out.replace(/”/gi, "``").toString();
    out = out.replace(/“/gi, "``").toString();
    out = out.replace(/–/gi, "-").toString();
    return out;
  }

  async uploadActMasGen(plantilla) {
    let jsonUpdate = [];
    plantilla.splice(0, 1);
    jsonUpdate = plantilla;
    console.log('jsonUpdate: ', jsonUpdate);
    let publicError = [];
    this.countUP_1 = 0;
    this.showLoad = true;
    for (let j of jsonUpdate) {
      if (
        j.Stock != null
          && j.PrecioPublic != null
          && j.IVA != null
          && j.ComisionDenario != null
          && j.Estado != null
          && j.Descripcion != null
      ) {
        if (j.DescuentoPromo == null) { j.DescuentoPromo = 0; }
        if (j.FechaIniPromo == null) { j.FechaIniPromo = "2000-12-31"; }
        if (j.FechaFinPromo == null) { j.FechaFinPromo = "2000-12-31"; }
        if (j.StockPRH == null) { j.StockPRH = 50; }
        let pregArray = j.Descripcion.split(",,");
        j.Descripcion = [];
        pregArray.forEach(preg => {
          j.Descripcion.push({
            id: 'new',
            name: "",
            valor: this.sqlAdapt(preg)
          })
        });
        j.Descripcion = JSON.stringify(j.Descripcion);
        j.DimensionStr = j.Dimension || "10,10,10";
        console.log("aqui se cargan las actualizaciones...");
        let body = {
          public:j,
          usr:this.user.Usuario
        };
        let httpResProm = new Promise((resolve, reject) => {
          this.http.post(environment.urlApi + 'uploadpublicacionmk4', body, this.HTTPoptions).subscribe(
            (res: any) => {
              this.countUP_1 = this.countUP_1 + 1;
              resolve("ok "+this.countUP_1+": " + j.Id);
            },
            (err) => {
              publicError.push({
                Id: j.Id,
                SKU: j.SKU,
                Error: JSON.stringify(err)
              });
              resolve("fail " + j.Id + ": " + err);
            }
          );
        });
        let respuesta = await httpResProm;
        console.log(respuesta);
      } else {
        publicError.push({
          Id: j.Id,
          SKU: j.SKU,
          Error: "Algún campo obligatorio vacio."
        });
      }
    }
    this.showLoad = false;
    this.getPublicMarket();
    if (publicError.length > 0) {
      this.exportAsExcelFile(publicError, 'publicError');
      this.presentAlert('Alerta', 'Algunas actualizaciones no se aplicaron', 'Por favor revisa el archivo "publicError.xlsx" para mas información.');
    } else {
      this.presentToast('Todo se actualizó correctamente!');
    }
  }


  /* PLANTILLA MASIVA STOCK */

  downloadPlantillaPublicMasivaStock() {
    console.log('publicaciones: ', this.publicaciones);
    let plantilla = [];
    plantilla.push({
        Id: "(No editable)"
      , SKU: "(No editable)"
      , Titulo: "(No editable)"
      , Stock: "(*) (Numero entero)"
      , Estado:  "(*) 1: Activo, 0: Inactivo"
    });
    this.publicaciones.forEach(p => {
      if (p.Estado == 0 || p.Estado == 1) {
        plantilla.push({
            Id: p.Id
          , SKU: p.CodUniversal
          , Titulo: p.Titulo
          , Stock: p.Stock
          , Estado: p.Estado
        });
      }
    });
    console.log('plantilla: ', plantilla);
    this.exportAsExcelFile(plantilla, 'PlantillaPublicMasStock');
  }

  async onFileChangeMasStock(ev) {
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev.target.files[0];
    reader.onload = async (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});
      /* console.log('DataJson: ', jsonData); */
      if (jsonData.PlantillaPublicMasStock) {
        this.onFileChangeMasStockAlert(jsonData.PlantillaPublicMasStock);
      } else {
        this.presentAlert("Error al subir plantilla", "Nombre de hoja de calculo", "Por favor cambia el nombre de la hoja de excel a PlantillaPublicMas");
      }
    }
    reader.readAsBinaryString(file);
  }

  async onFileChangeMasStockAlert(plantilla: any) {
    this.plantillaLength = plantilla.length;
    const alert = await this.alertController.create({
      mode:'ios',
      header: 'Confirma!',
      message: '<strong>Actualizaciones: </strong>'+(this.plantillaLength-1),
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Confirmar',
          handler: () => {
            console.log('Confirm Okay');
            if (!this.showLoad) {
              this.uploadActMasStock(plantilla);
            } else {
              this.presentToast('Por favor espera...');
            }
          }
        }
      ]
    });
    await alert.present();
  }

  countActP = 0;
  async uploadActMasStock(plantilla) {
    let jsonUpdate = [];
    plantilla.splice(0, 1);
    jsonUpdate = plantilla;
    console.log('jsonUpdate: ', jsonUpdate);
    let publicError = [];
    this.countUP_1 = 0;
    this.countActP = 0;
    this.showLoad = true;
    for (let j of jsonUpdate) {
      if (
        j.Stock != null
      ) {
        console.log("aqui se cargan las actualizaciones...");
        let body = {
          public:j,
          usr:this.user.Usuario
        };
        let httpResProm = new Promise((resolve, reject) => {
          this.http.post(environment.urlApi + 'uploadpublicacionmk5', body, this.HTTPoptions).subscribe(
            (res: any) => {
              this.countUP_1 = this.countUP_1 + 1;
              this.countActP = this.countUP_1 / jsonUpdate.length;
              resolve("ok "+this.countUP_1+": " + j.Id);
            },
            (err) => {
              publicError.push({
                Id: j.Id,
                SKU: j.SKU,
                Error: JSON.stringify(err)
              });
              resolve("fail " + j.Id + ": " + err);
            }
          );
        });
        let respuesta = await httpResProm;
        console.log(respuesta);
      } else {
        publicError.push({
          Id: j.Id,
          SKU: j.SKU,
          Error: "Algún campo obligatorio vacio."
        });
      }
    }
    this.showLoad = false;
    this.getPublicMarket();
    if (publicError.length > 0) {
      this.exportAsExcelFile(publicError, 'publicError');
      this.presentAlert('Alerta', 'Algunas actualizaciones no se aplicaron', 'Por favor revisa el archivo "publicError.xlsx" para mas información.');
    } else {
      this.presentToast('Todo se actualizó correctamente!');
    }
  }

  /* FIN PLANTILLA STOCK */

  async changeToActivoAlert(publicacion) {
    console.log(publicacion);
    const alert = await this.alertController.create({
      mode:'ios',
      header: 'Confirma!',
      message: '<strong>Activar publicación</strong>',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Confirmar',
          handler: () => {
            console.log('Confirm Okay');
            this.cangeEstadoPublicApi(publicacion,1);
          }
        }
      ]
    });
    await alert.present();
  }

  async changeToInactivoAlert(publicacion) {
    console.log(publicacion);
    const alert = await this.alertController.create({
      mode:'ios',
      header: 'Confirma!',
      message: '<strong>Inactivar publicación</strong>',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Confirmar',
          handler: () => {
            console.log('Confirm Okay');
            this.cangeEstadoPublicApi(publicacion,0);
          }
        }
      ]
    });
    await alert.present();
  }

  async cangeEstadoPublicApi(publicacion, estado) {
    let p = {
      Id: publicacion.Id,
      Estado: estado
    }
    let body = {
      public:p,
      usr:this.user.Usuario
    };
    await this.presentLoading('Cambiando estado...');
    this.apiOnReq = true;
    this.http.post(environment.urlApi + 'uploadPublicacionmkestado', body, this.HTTPoptions).subscribe((res: any) => {
      this.loading.dismiss();
      this.apiOnReq = false;
      clearTimeout(this.temporizador);
      console.log(res);
      publicacion.Estado = estado;
    });
    
  }


  prinImg: any;
  irDetProducto(prod) {
    this.popoverController.dismiss();
    this.producto = prod;
    this.producto.Descripcion = this.producto.Preguntas
    console.log("Detalle del producto: ", this.producto);
    if (this.producto) {
      this.prinImg = this.producto.Img;
      this.router.navigate(['/det-producto']);
    }
  }

  numImage = 0;
  selectPrinImg(img) {
    console.log('selectPrinImg: ', img);
    this.prinImg = img;
    this.numImage = this.producto.Images.indexOf(img) +1;
    console.log(this.numImage);
  }

  getValDesc() {
    let hoy = Date.now(); 
    console.log("fecha hoy: ", hoy);
    let iniPromo = new Date(this.producto.FechaIniPromo).getTime();
    let finPromo = new Date(this.producto.FechaFinPromo).getTime();
    let descP = 0; if (iniPromo <= hoy && finPromo >= hoy) { descP = this.producto.DescPromo; }
    let iniDenario = new Date(this.producto.FechaIniDenario).getTime();
    let finDenario = new Date(this.producto.FechaFinDenario).getTime();
    let descD = 0; if (iniDenario <= hoy && finDenario >= hoy) { descD = this.producto.DescDenario; }
    let iniOtros = new Date(this.producto.FechaIniOtros).getTime();
    let finOtros = new Date(this.producto.FechaFinOtros).getTime();
    let descO = 0; if (iniOtros <= hoy && finOtros >= hoy) { descO = this.producto.DescOtros; }

    this.producto.PrecioD = (this.producto.ValorUnt * (100 - descP - descD) / 100);
    this.producto.PrecioO = (this.producto.ValorUnt * (100 - descP - descO) / 100);
  }

  proveedores = [];
  proveedoresFilt = [];
  async getProveedores() {
    if (this.ciudadesDane.length == 0) {
      await this.getCiudades();
    }
    await this.presentLoading('Consultando proveedores...');
    this.apiOnReq = true;
    const reqHttp = new Promise((resolve, reject) => {
      this.http.get(environment.urlApi + 'market/getProveedores', this.HTTPoptions).subscribe(
        (res: any) => {
          this.endLoading();
          res.forEach(prov => {
            this.fixProveedor(prov);
          });
          this.proveedores = res;
          this.proveedoresFilt = res;
          console.log('proveedores: ', this.proveedores);
          resolve(1);
        }
        , (err) => {
          this.endLoading();
          this.presentAlert('Error', 'Al consultar proveedores', JSON.stringify(err));
          resolve(0);
        }
      ); 
    })
    await reqHttp;
    this.updateFilter4(this.busqueda4);
  }

  ciudadesDane = [];
  ciudadesDaneFilt = [];
  async getCiudades() {
    await this.req('get', 'interr/getCiudadesDane', {}, 'Obteniendo ciudades...')
      .then((res: any) => {
        this.ciudadesDane = res;
        this.ciudadesDaneFilt = res;
        console.log('ciudadesDane: ', this.ciudadesDane);
      })
      .catch((err) => {
        this.presentAlert('Error', 'al obtener ciudades', JSON.stringify(err));
      })
  }

  async fixProveedor(prov) {
    let comisionDBArray = [];
    if (prov.Comision) { comisionDBArray = JSON.parse(prov.Comision); } 
    if (!comisionDBArray[0]) {
      comisionDBArray[0] = {
        IdCategoria: 0,
        Nombre: 'Por Defecto',
        Valor: null
      }
    }
    prov.comisionArr = [];
    prov.comisionArr.push(comisionDBArray[0])
    this.cat.forEach(c => {
      const catDB = comisionDBArray.find(f => f.IdCategoria == c.IdCategoria)
      let valor;
      if (catDB) {
        /* console.log(prov, ' - ', catDB); */
        valor = catDB.Valor;
      }
      prov.comisionArr.push({
        IdCategoria: c.IdCategoria,
        Nombre: c.Nombre,
        Valor: valor
      })
    });
    /* if (prov.Comision) {
      prov.comisionArr = JSON.parse(prov.Comision);
    } else {
      prov.comisionArr = [];
    }
    if (!prov.comisionArr[0]) {
      prov.comisionArr[0] = {
        IdCategoria: 0,
        Nombre: 'Por Defecto',
        Valor: null
      }
    }
    this.cat.forEach(c => {
      const index = prov.comisionArr.indexOf(p => p.Nombre == c.Nombre);
      if (index == -1) {
        prov.comisionArr.push({
          IdCategoria: c.IdCategoria,
          Nombre: c.Nombre,
          Valor: null
        })
      }
    }); */
    if (!prov.EnInterr) {
      prov.EnInterr = 0;
    } else {
      prov.EnInterr = 1;
    }
    if (!prov.CorigenInter) {
      prov.CorigenInter = '11001000';
      prov.CiudadOrigen = 'BOGOTÁ D.C. - BOGOTA D.C.'
    } else {
      let ciudadFind = this.ciudadesDane.find(f => f.Cod == prov.CorigenInter)
      prov.CiudadOrigen = `${ciudadFind.Ciudad} - ${ciudadFind.Departamento}`;
    }
    if(prov.Recogida==null ){prov.Recogida=true;}
  }

  estadosProvSelectChan(event){
    console.log('estadosDesSelect: ',event.detail.value);
    this.updateFilter4(this.busqueda4);
  }

  filtProvEstados(){
    let tempFilt=[];
    this.estadosProveedorSelectValue.forEach(estado => {
      const found = this.proveedoresFilt.filter(p => p.En == estado);
      tempFilt = tempFilt.concat(found);
    });
    this.proveedoresFilt = tempFilt;
    console.log('proveedoresFilt: ',this.proveedoresFilt);
  }

  updateFilterHtml4(event) {
    this.updateFilter4(event.detail.value);
  }

  updateFilter4(event) {
    const val = event.toLowerCase().trim();
    // filter our data
    this.proveedoresFilt = this.proveedores.filter((d) => {
      d.Nit = d.Nit || "";
      d.Correo = d.Correo || "";
      return (
           d.Nit.toString().indexOf(val) !== -1 
        || d.Usr.toLowerCase().indexOf(val) !== -1  
        || d.Correo.toLowerCase().indexOf(val) !== -1 
        || !val);
    });
    this.filtProvEstados();
  }


  facturas = [];
  facturasFilt = [];
  async getFacturacion(){
    console.log('Cargando datos de facturacion...');
    await this.presentLoading('Cargando datos de facturacion...');
    this.apiOnReq = true;
    let body = {
      rol: this.user.IdRol,
      usr: this.user.Usr
    };
    const httpReq = new Promise((resolve, reject) => {
      this.http.post(environment.urlApi + 'market/getFacturacion', body, this.HTTPoptions).subscribe(
        (res: any) => {
          this.endLoading();
          console.log('res: ', res);
          res = res.sort((a, b) => b.Id - a.Id);
          res.forEach(c => {
            /* c.Categoria = this.cat.find(a => a.IdCategoria == c.IdCategoria).Nombre || 'Categoría no existente'; */
            const categoria = this.cat.find(a => a.IdCategoria == c.IdCategoria);
            c.Categoria = categoria ? categoria.Nombre : 'Categoría no existente';
            c.Select = true;
            const provComisiones = this.proveedores.find(p => (p.Usr.toLowerCase()).trim() == (c.Proveedor.toLowerCase()).trim());
            if(!provComisiones){
              c.Comision = 0
            }else{
              /* c.Comision = provComisiones.comisionArr.find(p => p.IdCategoria == c.IdCategoria).Valor || provComisiones.comisionArr[0].Valor; */
              const comision = provComisiones.comisionArr.find(p => p.IdCategoria == c.IdCategoria);
              c.Comision = comision ? (comision.Valor ? comision.Valor : provComisiones.comisionArr[0].Valor) : provComisiones.comisionArr[0].Valor;
              /* if(comision){
                c.Comision = comision.Valor ? comision.Valor : provComisiones.comisionArr[0].Valor;
              } else {
                c.Comision = provComisiones.comisionArr[0].Valor;
              } */
            }
            switch (c.IdMetodo) {
              case 1: c.MetodoName = 'Credito Denario'; break;
              case 2: c.MetodoName = 'PSE'; break;
              case 3: c.MetodoName = 'Boton Tpaga'; break;
              case 4: c.MetodoName = 'MiniApp Tpaga'; break;
              case 10: c.MetodoName = 'Puntos Gmovil'; break;
            
              default: c.MetodoName = 'Desconocido'; break;
            }
          });
          this.facturas = res;
          this.facturasFilt = res;
          resolve(1);
        },
        (err) => {
          console.log('Error http: ', err);
          this.endLoading();
          this.presentAlert('Error: ', 'Al consultar facturación', JSON.stringify(err));
          resolve(0);
        });
    })
    await httpReq;
  }

  endLoading() {
    this.loading.dismiss();
    this.apiOnReq = false;
    clearTimeout(this.temporizador);
  }

  sinTildes(entrada) {
    if (entrada == null) { entrada = ""; }
    let input = entrada.toString();
    var tittles = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç´";
    var original = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc ";
    for (var i = 0; i < tittles.length; i++) {
        input = input.replace(tittles.charAt(i), original.charAt(i)).toLowerCase().trim();
    };
    return input;
  }

  async req(tipo, path, body = {}, mssLoading, loadingEn = true) {
    if (!this.apiOnReq) {
      this.apiOnReq = true;
      if (loadingEn) { await this.presentLoading(mssLoading); }
      return new Promise((resolve, reject) => {
        switch (tipo.toLowerCase()) {
          case "get":
            this.http.get(environment.urlApi + path, this.HTTPoptions).subscribe(
              (res: any) => {
                this.apiOnReq = false;
                if (this.loading) { this.loading.dismiss() };
                clearTimeout(this.temporizador);
                console.log(`${path}: `, res);
                resolve(res);
              }
              , (error) => {
                this.apiOnReq = false;
                if (this.loading) { this.loading.dismiss() };
                clearTimeout(this.temporizador);
                console.log(`${path} error: `, error);
                reject(error);
              }  
            );
            break;
          case "post":
            this.http.post(environment.urlApi + path, body ,this.HTTPoptions).subscribe(
              (res: any) => {
                this.apiOnReq = false;
                if (this.loading) { this.loading.dismiss() };
                clearTimeout(this.temporizador);
                console.log(`${path}: `, res);
                resolve(res);
              }
              , (error) => {
                this.apiOnReq = false;
                if (this.loading) { this.loading.dismiss() };
                clearTimeout(this.temporizador);
                console.log(`${path} error: `, error);
                reject(error);
              }   
            );
            break;
          default:
            break;
        }
      })
    }
  }

  isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
  }

  isEmptyObj(obj) {
    if (JSON.stringify(obj).length > 2) {
      return false;
    } else {
      return true;
    }
  }

  transformUrl(url){
    return this.dom.bypassSecurityTrustResourceUrl(url);
  }

  imgToView;
  irImageView(img) {
    this.imgToView = img;
    this.router.navigate(['/image-view']);
  }
  
  pdfToView;
  irPdfView(pdf) {
    this.pdfToView = pdf;
    this.router.navigate(['/pdf-view']);
  }

  downloadPDF(pdf,name) {
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement("a");
    const fileName = `${name}.pdf`;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  


























  verRol(funcion:string):boolean{
    if(this.user){
      if(this.user.IdRol==100){ //super usuarios
        return true;
      }else{
        switch (funcion) {
          /* case 'verReporte': if(this.user.IdRol == 301 || this.user.IdRol ==302 || this.user.IdRol ==400 ){return true;}else{return false;} */
          default:
            return false;
        }
      }
    }
  }



}
